import React from 'react'
import { dateFormatterUTC, formatDeliveryDate } from '@usap/core'
import {
  formatShippingMethod,
  arrangeShippingMethods,
  formatShippingMethodV2,
} from '../formatShippingMethod'
import {
  StyledDeliveryDate, StyledMethodContainer, StyledTable, StyledTableCell, StyledTableHeader,
} from './DatesWmo.css'
import { GetShippingIcon } from '../GetShippingIcon'

interface DatesWmoProps {
  shippingOption: ShippingOption
  isEconomyShippingEnabled: boolean
  unfoldedShippingConfig: any
  isUnfoldedShippingEnabled: boolean
  unfoldedShippingVariant: string
  isProductValidForUnfoldedShipping?: boolean
  isLastMile?: boolean
}
interface ShippingOption {
  options: Option[]
}
interface Option {
  method: string;
  deliveryDate?: string;
  deliveryDateFrom?: string;
  deliveryDateTo?: string;
}

const formatMethodLabel = (
  method: string,
  isUnfoldedShippingEnabled: boolean,
  isProductValidForUnfoldedShipping: boolean,
  unfoldedShippingVariant: string,
  unfoldedShippingConfig: any,
): string => {
  if (isUnfoldedShippingEnabled && isProductValidForUnfoldedShipping) {
    return formatShippingMethodV2(method, unfoldedShippingVariant, unfoldedShippingConfig)
  }
  return formatShippingMethod(method)
}

const DatesWmo = ({
  shippingOption,
  isEconomyShippingEnabled,
  unfoldedShippingConfig,
  isUnfoldedShippingEnabled,
  unfoldedShippingVariant,
  isProductValidForUnfoldedShipping = false,
  isLastMile = false,
}: DatesWmoProps) => {
  const options = arrangeShippingMethods(shippingOption?.options)

  const filteredOptions = options.filter(option => {
    if (!isEconomyShippingEnabled && option?.method === 'Economy') return false
    if (option?.method === 'Ground_unfolded') return false
    return true
  })

  return (
    <StyledTable>
      <thead>
        <tr>
          <StyledTableHeader>
            <span>Shipping Method</span>
            <small>**</small>
          </StyledTableHeader>
          <StyledTableHeader>Delivery Date</StyledTableHeader>
        </tr>
      </thead>
      <tbody>
        {filteredOptions.map(option => (
          <tr key={option.method}>
            <StyledTableCell>
              {isLastMile
                ? (
                  <StyledMethodContainer>
                    <GetShippingIcon dMethod={option.method} />
                    {formatMethodLabel(
                      option.method,
                      isUnfoldedShippingEnabled,
                      isProductValidForUnfoldedShipping,
                      unfoldedShippingVariant,
                      unfoldedShippingConfig,
                    )}
                  </StyledMethodContainer>
                )
                : formatMethodLabel(
                  option.method,
                  isUnfoldedShippingEnabled,
                  isProductValidForUnfoldedShipping,
                  unfoldedShippingVariant,
                  unfoldedShippingConfig,
                )}
            </StyledTableCell>
            {(option?.method !== 'Economy' && option?.deliveryDate) && (
              <StyledDeliveryDate>
                {isLastMile && option?.cutoffTime
                  ? formatDeliveryDate(option?.deliveryDate, option?.cutoffTime)
                  : dateFormatterUTC(option.deliveryDate)}
              </StyledDeliveryDate>
            )}
            {(option?.method === 'Economy' && option?.deliveryDateFrom && option?.deliveryDateTo) && (
              <StyledDeliveryDate>
                {isLastMile && option?.cutoffTime
                  ? formatDeliveryDate(option.deliveryDateFrom, option?.cutoffTime) : dateFormatterUTC(option.deliveryDateFrom)}
                {' - '}
                {isLastMile && option?.cutoffTime
                  ? formatDeliveryDate(option.deliveryDateTo, option?.cutoffTime) : dateFormatterUTC(option.deliveryDateTo)}
              </StyledDeliveryDate>
            )}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  )
}

export default DatesWmo
